import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AmdocsUiModule } from 'amdocs-core-package';
import { AmdocsTranslateService } from 'amdocs-auth-package';
// Import for Lottie animations
import { LottieComponent,provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';

// Note we need a separate function as it's required by the AOT compiler
export function playerFactory() {
  return player;
}
import { AvatarComponent } from './components/avatar/avatar.component';
import { LearningPopupComponent } from './components/learning-popup/learning-popup.component';
import { LotteryPopupComponent } from './components/lottery-popup/lottery-popup.component';
import { MaintenancePopupComponent } from './components/maintenance-popup/maintenance-popup.component';
import { OnBoardingComponent } from './components/onboarding/on-boarding.component';
import { QrReaderComponent } from './components/qr-reader/qr-reader.component';
import { VersionUpdateComponent } from './components/version-update/version-update.component';
import { WinnersPodiumComponent } from './components/winners-podium/winners-podium.component';
import { AmdocsImageFallbackDirective } from './directives/amdocs-image-fallback.directive';
import { TextareaAutoResizeDirective } from './directives/text-area-auto-resize.directive';
import { TrimLeadingWhitespaceDirective } from './directives/trim-leading-white-space.directive';
import { AmdocsAppErrorComponent } from './components/amdocs-app-error/amdocs-app-error.component';
import { AmdocsSwiperComponent } from './components/amdocs-swiper/amdocs-swiper.component';
// Lottie animation components should be imported directly in components that need them

const shareComponents = [
  AvatarComponent,
  QrReaderComponent,
  QrReaderComponent,
  AmdocsImageFallbackDirective,
  TrimLeadingWhitespaceDirective,
  TextareaAutoResizeDirective,
  AmdocsAppErrorComponent,
  VersionUpdateComponent,
  WinnersPodiumComponent,
  LotteryPopupComponent,
  LearningPopupComponent,
  MaintenancePopupComponent,
  OnBoardingComponent,
  AmdocsSwiperComponent
];

@NgModule({
  declarations: [...shareComponents],  imports: [
    LottieComponent,
    AmdocsUiModule,
    CommonModule
  ],
  providers: [
    provideLottieOptions({
      player: playerFactory
    }),
    AmdocsTranslateService
  ],
  exports: [AmdocsUiModule, ...shareComponents],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ShareModule { }
